import React, {useContext, useMemo } from 'react'
import { Page, Text, View, Document, PDFViewer, Image, PDFDownloadLink} from '@react-pdf/renderer';
import { v4 as uuid } from 'uuid';
import UserContext from '../../../context/Globales/UserContext';
import moment from 'moment';
import { UrlqrPdf } from '../../../helpers/UrlqrPdf';
const IcpdfConyuge = () => {

    moment.locale('spanish');
    const Fecha = moment().format('LLLL'); // FORMATO: Domingo 15 Julio 2012 11:01
    
    const { Datodetalleconyuge, datoICPDF } = useContext(UserContext);
    const dataUrlQr = UrlqrPdf();
  //console.log('Datodetalleconyuge',Datodetalleconyuge);

  

    const TblConyuge =(

        <>
            <View style={{ fontSize: 9 }}>
            <View style={{ flexDirection: 'row', fontSize: 9 }}>
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Nombre del  Conyuge:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{Datodetalleconyuge?.Nombre}</Text>
            </View>
            <View style={{ flexDirection: 'row', fontSize: 9 }}>
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Rut:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{Datodetalleconyuge?.Rut}</Text>
            </View>
            <View style={{ flexDirection: 'row', fontSize: 9 }}>
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Fecha Nacimiento:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{Datodetalleconyuge?.FechaNacimiento}</Text>
            </View>
            <View style={{ flexDirection: 'row', fontSize: 9 }}>
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Edad:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{Datodetalleconyuge?.Edad}</Text>
            </View>
            <View style={{ flexDirection: 'row', fontSize: 9 }}>
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Fecha Matrimonio:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{Datodetalleconyuge?.FechaMatrimonio}</Text>
            </View>
            <View style={{ flexDirection: 'row', fontSize: 9 }}>
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Dirección:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{Datodetalleconyuge?.Direccion}</Text>
            </View>

            <View style={{ flexDirection: 'row', fontSize: 9 }}>
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Comuna:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{Datodetalleconyuge?.Comuna}</Text>
            </View>
            <View style={{ flexDirection: 'row', fontSize: 9 }}>
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Ciudad:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{Datodetalleconyuge?.Ciudad}</Text>
            </View>
            </View>
        </>

    );


const ReportepdfConyuge =()=>(
      
    <Document >
            
    <Page size="letter" style={{ paddingTop: 15, paddingBottom: 40, paddingHorizontal: 20 }}>
        <View>


            <Image src={process.env.PUBLIC_URL + '/static/imagen/logonewp.png'} style={{ width: '100%', padding: '2' }} fixed />
          
            <Text style={{ fontSize: 9, textAlign: 'right' }} fixed>FECHA IMPRESIÓN: {Fecha} </Text>
            <Text style={{ fontSize: 10, textAlign: 'right' }} render={({ pageNumber, totalPages }) => (`PÁGINA ${pageNumber} / ${totalPages}`)} fixed />
           
            <View fixed>
                <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#bbdefb', color: 'black', marginTop: 8, padding: '5,15' }}  >{datoICPDF.Identificacion?.IsEmpresa ? datoICPDF.DetalleIdentificacionEmpresa?.Nombre : datoICPDF.Identificacion?.Nombre} RUT {datoICPDF.Identificacion?.Rut}</Text>
            </View>

            <View style={{ width: '100%' }}>
                <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>DATOS DEL CONYUGE</Text>
                { TblConyuge }
            </View>

            <View style={{ width: '50%', alignContent: 'left' }}>
            
                {/*<Image src={process.env.PUBLIC_URL + '/static/imagen/IconoEmpresa/qrPortacheque.png'} style={{ width: '30%', padding: '5' }} /> */}
                <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}  >Nro. FOLIO: {datoICPDF.ID} - {uuid(datoICPDF.ID)}</Text>
            </View>

        </View>


    </Page>

</Document>
);


return useMemo(
    ()=>(
    <div>

    
       <PDFDownloadLink  document={<ReportepdfConyuge />} fileName={`${uuid()}.pdf`}>
           
       {({ blob, url, loading, error }) => (loading ? <h2 style={{ textAlign: 'center', fontSize: '18px' }}>Ten paciencia, estamos generando el PDF... </h2> : <h2 style={{ textAlign: 'center', fontSize: '22px' }}>DESCARGAR ARCHIVO PDF</h2>)}
      
        </PDFDownloadLink>
        
       

    </div>
),[]

);
}

export default IcpdfConyuge
